<template>
	<div id="paxExpress" class="pax_global">
		<div class="tabs mb-3 d-lg-none">
			<ul class="nav nav-tabs nav-justified">
				<li class="nav-item"><a class="nav-link" :class="{'active' : step < 1}" @click="openMenu"><b><font-awesome-icon :icon="['fas', 'home']"/></b><span>{{ $t('pax.accueil') }}</span></a></li>
				<li class="nav-item"><a class="nav-link" :class="{'disabled' : step < 1, 'active': step === 1}" @click="goToStep(1)"><b>1</b><span>{{ $t('pax.etalons') }}</span></a></li>
				<li class="nav-item"><a class="nav-link" :class="{'disabled' : step < 2, 'active': step === 2}" @click="goToStep(2)"><b>2</b><span>{{ $t('pax.comparaison') }}</span></a></li>
				<li class="nav-item"><a class="nav-link" :class="{'disabled' : step < 3, 'active': step === 3}" @click="goToStep(3)"><b>3</b><span>{{ $t('pax.graphique') }}</span></a></li>
			</ul>
		</div>
		
		<div class="container-fluid">
			<div class="row justify-content-center">
				<div class="col-12 col-lg-6 bmare" v-show="step === 1">
					<Mare :force_refresh="force_refresh" :mare="mare" :criteres.sync="criteres" :stallions="stallions_selected"></Mare>
				</div>
				<div class="col-12 col-lg-6 bmare" v-show="step === 1">
					<PaxSuggestionResult :criteres="criteres" :mare="mare" :suggestion.sync="suggestion" :displayCompatibilite.sync="displayCompatibilite" :step_label.sync="step_label" :stallions_comparaison.sync="stallions_comparaison" ></PaxSuggestionResult>
				</div>
				<div class="col-12" v-show="step === 2">
					<ResultCompatibiliteV :stallions="stallions_comparaison" :stallion_id.sync="stallion_id" :step.sync="step" :criteres="criteres" :mare="mare" :step_label.sync="step_label" :show="step === 2"></ResultCompatibiliteV>
				</div>
				<div class="col-12" v-if="step === 3">
					<PaxGraphique :step.sync="step" :mare="mare" :stallions="stallions_comparaison" :stallion_id="stallion_id" :step_label.sync="step_label"></PaxGraphique>
				</div>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import Navigation from '@/mixins/Navigation.js'
	import PaxMixin from '@/mixins/Pax.js'
	import Config from '@/mixins/Config.js'
	import Window from '@/mixins/Window.js'
	import Horse from '@/mixins/Horse.js'
	import _uniqueId from 'lodash/uniqueId'

	export default {
		name: 'HorsePaxSuggestion',
		props: ['horse_id'],
		mixins: [Navigation, PaxMixin, Config, Window, Horse],
		data () {
			return {
				stallions_selected: [],
				criteres: [],
				mare: {},
				displayCompatibilite: false,
				force_refresh: null,
				stallion_id: null,
				step: 1,
				step_label: 'mare_list',
				steps: {'mare_list': 1, 'comparaison_V': 2, 'pax_graphique': 3},
				stallions_preselected: [],
				from_preselected: false,
				stallions_comparaison: [],
				suggestion: [],
				skipStepWatch: false // garde anti-boucle : empêche le watcher step_label de push router lors d'un beforeRouteUpdate
			}
		},

		beforeRouteUpdate(to, from, next) {
			// Restaure l'étape depuis la query URL (retour/avant navigateur)
			const queryToStepLabel = {
				'compare': 'comparaison_V',
				'graphique': 'pax_graphique'
			}
			const toLabel = queryToStepLabel[to.query.pax_step] || 'mare_list'
			this.skipStepWatch = true
			this.step_label = toLabel
			this.step = this.steps[toLabel]
			this.$nextTick(() => { this.skipStepWatch = false })
			next()
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				document.querySelector('html').classList.remove('no_scroll')
				this.mare = await this.getHorseById(this.horse_id)
				this.stallions_selected = []
				this.displayCompatibilite = false
				this.criteres = []
				this.stallions_preselected = []
				// au reload permet de mettre à jour les critères à l'étape pax
				this.force_refresh = _uniqueId()

				if(this.$route.params.stallion_ids) {
					this.stallions_preselected = this.$route.params.stallion_ids.split(',').map(s => parseInt(s))
					this.from_preselected = true
				}
				else {
					const stallions = await this.getMarePanier(this.horse_id)
					if(stallions) {
						this.from_preselected = true
						this.stallions_preselected = stallions.map(stallion => stallion.panier_stallion)
					}
				}

				// Si accès direct à une sous-étape sans données, revenir à l'étape de base
				if(this.$route.query.pax_step) {
					this.$router.replace({ name: 'HorsePaxSuggestion', params: { horse_id: this.horse_id } })
				}
			},

			goToHome() {
				this.init_component()
			},

			goToStep(step_to_go) {
				if(step_to_go < this.step) {
					this.step_label = Object.keys(this.steps).find(key => this.steps[key] === step_to_go)
				}
			},

			openMenu() {
				this.$store.commit('nav/open')
			}
		},

		watch: {
			step_label(val) {
				if(this.skipStepWatch) return

				if(val == 'stallions_selected' && this.from_preselected) {
					this.from_preselected = false
					this.step = this.steps['mare_list']
				}
				else if(val == 'comparaison_V') {
					this.step = this.steps[val]
					this.$router.push({ name: 'HorsePaxSuggestion', params: { horse_id: this.horse_id }, query: { pax_step: 'compare' } })
				}
				else if(val == 'pax_graphique') {
					this.step = this.steps[val]
					this.$router.push({ name: 'HorsePaxSuggestion', params: { horse_id: this.horse_id }, query: { pax_step: 'graphique' } })
				}
				else {
					this.step = this.steps[val]
					// Nettoie le query param si l'URL en a un (ex: retour depuis comparaison)
					if(this.$route.query.pax_step) {
						this.$router.replace({ name: 'HorsePaxSuggestion', params: { horse_id: this.horse_id } })
					}
				}
			},
			'suggestion': {
				deep: true,
				handler(val) {
					this.step_label = 'stallions_selected'
					this.stallions_selected = this.stallions_selected.concat(val)
				}
			}
		},

		components: {
			Stallions: () => import('@/components/Pax/Stallions'),
			Mare: () => import('@/components/Pax/Mare'),
			PaxSuggestionResult: () => import('@/components/Horse/PaxSuggestionResult'),
			ResultCompatibiliteHFull: () => import('@/components/Pax/ResultCompatibiliteHFull'),
			ResultCompatibiliteV: () => import('@/components/Pax/ResultCompatibiliteV'),
			PaxGraphique: () => import('@/components/Pax/PaxGraphique'),
			ChoixLangue: () => import('@/components/Pax/ChoixLangue'),
			ChoixCountry: () => import('@/components/Pax/ChoixCountry')
		}
	}

</script>